// Validates an avatar URL is safe to render in <img src>. Allowlist is
// intentionally narrow: https only, hostname must be googleusercontent.com or
// a subdomain (covers lh3/lh4/lh5/etc., Google's avatar CDN hosts).
// Anything else → false → caller renders the initials fallback.

export function isAllowedAvatarUrl(url: string | null | undefined): boolean {
  if (!url) return false
  let parsed: URL
  try {
    parsed = new URL(url)
  } catch {
    return false
  }
  if (parsed.protocol !== 'https:') return false
  const host = parsed.hostname
  return host === 'googleusercontent.com' || host.endsWith('.googleusercontent.com')
}
